goog.require('el8.template.multiuser_access.findChart');
goog.require('el8.multiuser_access.setup');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if (!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.findChart = (function() {

    var that = {};
    var theForm = null;


    function goToNextPage(faxCodeLookupResult) {
        // given a result from faxcode lookup, dispatch to next page
        if (faxCodeLookupResult.next === 'signup') {
            // send them to sign up flow
            location.href = el8.service.urls.get('pageSignUp', [faxCodeLookupResult.fax_code]);
        }
        if (faxCodeLookupResult.next === 'choose-account') {
            // send them to choose account flow
            location.href = el8.service.urls.get('pageChooseAccount', [faxCodeLookupResult.fax_code]);
        }
    }

    function renderFaxCodeState(isSuccess) {
        // render success/error state
        if (isSuccess === null) {
            resetCodeStatus();
            $('#fax-code-container').removeClass("el8FormError").removeClass("el8FormSuccess");
            return;
        }
        if (isSuccess) {
            $('#fax-code-container').removeClass("el8FormError").addClass("el8FormSuccess");
            $('.code-not-accepted').hide();
            $('.code-accepted').show();
        } else {
            $('#fax-code-container').removeClass("el8FormSuccess").addClass("el8FormError");
            $('.code-not-accepted').show();
            $('.code-accepted').hide();

            // show a sample
            $('.sample-code').show();
        }
    }

    function checkFaxCode(faxCode, nextPage) {
        if (!faxCode) {
            // short-cut
            renderFaxCodeState(false);
            return;
        }
        // make a server code to check if the faxCode is valid
        $.el8_ajax({
            url: el8.service.urls.get('faxCodeLookup', [faxCode]),
            data: null,
            async: true,
            success: function(data) {
                renderFaxCodeState(!data.error);
                if (nextPage && data.next) {
                    goToNextPage(data);
                } else if (data.result && data.result === 'expired') {
                    location.href=el8.service.urls.get('pageExpiredCode', [faxCode]);
                } else {

                }
            }
        });
    }

    function resetCodeStatus() {
        $('.code-accepted').hide();
        $('.code-not-accepted').hide();
    }

    function setupTriggers() {

        resetCodeStatus();

        // set up varies event listeners
        var faxCodeField = $('#fax-code');

        var validateOnPress = function(event) {
            // based on https://github.com/stripe/jquery.payment
            renderFaxCodeState(null);

            if (event.metaKey || event.ctrlKey) {
                return true;
            }

            if (event.which === 13 || event.keyCode === 13) {
                // submit the form
                checkFaxCode(faxCodeField.val(), true);
            }

            if (faxCodeField.val().length > 0) {
               $('#submit-code').prop('disabled', false);
            } else {
               $('#submit-code').prop('disabled', true);
            }


            if (!event.charCode) {
                // if we dont have a charCode, just let it thru
                // this means IE8 will not go thru this at all because IE8 event.charCode is always undefined
                return true;
            }

            var charCode = event.charCode;

            // Space
            if (charCode === 32) { return true; }

            // If charCode is a special char (WebKit)
            if (charCode === 0) { return true; }
            // If char is a special char (Firefox)
            if (charCode === 33) { return true; }


            var entry = String.fromCharCode(charCode);
            var validChars = /[a-z,A-Z,0-9]$/;
            if (!validChars.test(entry)) {
                event.preventDefault();
                return;
            }

            var newText = faxCodeField.val() + entry.toUpperCase();

            if (newText.length >= 11) {
                checkFaxCode(newText, false);
            }

            if (faxCodeField.val().length >= 11) {
                event.preventDefault();
            }
            else if (newText.length === 3 || newText.length === 7) {
                event.preventDefault();
                faxCodeField.val(newText + '-');
            } else {
                event.preventDefault();
                faxCodeField.val(newText);
            }
        };
        faxCodeField.on('keypress', validateOnPress);
    }

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */

        if (spec.urls) { el8.service.urls.init(spec.urls); }
        var container = $('.main-content');
        container.html(
            el8.template.multiuser_access.findChart.content({})
        );
        var content = container;

        theForm = new el8.uiwidget.Form({
            fields: [{
                name: 'faxCode',
                selector: ':input[name="faxCode"]',
                maxLength: 11
            }],
            container: $('#main-form')
        });
        theForm.render();

        // set up event listeners
        setupTriggers();

        $('#submit-code').prop('disabled', true);
        $('.sample-code').hide();

        content.on('click', '#submit-code',  function(event) {
            checkFaxCode(theForm.getVal('faxCode'), true);
        });

    };

    return that;

})();